export default __webpack_public_path__ + "static/media/CourtSelection2PT.3795b0e0.png";